import React from "react";

import Container from "../Container";
import H1 from "../H1";
import P from "./P";
import imgLauncher from "../../ic_launcher.png";
import Wrapper from "./Wrapper";
import TextBlue from "../TextBlue";
import i18n from "../../i18n";

function Header() {
  return (
    <Container>
      <Wrapper>
        <select
          style={{ position: "absolute", right: 10, width: 60, height: 40 }}
          onChange={(event) => {
            if (event.target.value === "EN") {
              i18n.changeLanguage("en");
            } else {
              i18n.changeLanguage("vi");
            }
          }}>
          <option style={{ fontSize: "13px" }} value="EN" selected>
            EN
          </option>
          <option value="VI">VI</option>
        </select>
        <img src={imgLauncher} alt="" />
        <H1>
          <TextBlue
            style={{
              marginTop: 10,
            }}>
            ChatEdu
          </TextBlue>
        </H1>
      </Wrapper>
    </Container>
  );
}

export default Header;
